module.exports = __webpack_public_path__ + "img/issues-grid-checkboxes.12cb2756.svg";